import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { TLoadoutsQuery } from "MVVM/Views/CreateMontage/@types";
import {
  LOADOUT_QUERY,
  ME_QUERY,
  QUICK_EDIT_GET_MOMENT,
} from "MVVM/GraphQL/quickEdit";
import { MOMENT_CREATE_CLIP } from "MVVM/GraphQL/mutations/momentRequestClip";
import { IQuickEditMoment } from "./@types";
import { CLIP_GAME_MAP } from "MVVM/Utilities/Maps";
import { MOMENT_CREATE_MONTAGE } from "MVVM/GraphQL/mutations/momentsCreateMontage";
import { MY_BALANCE } from "MVVM/GraphQL/montage";

export const QuickEditViewModel = (
  momentId: string,
  skipExtraQueries?: boolean,
) => {
  const { data: momentData } = useQuery<{ moment: IQuickEditMoment }>(
    QUICK_EDIT_GET_MOMENT,
    {
      variables: { id: momentId },
      skip: !momentId || skipExtraQueries,
    },
  );

  const gameId = Number(
    CLIP_GAME_MAP[momentData?.moment.game as keyof typeof CLIP_GAME_MAP],
  );

  const { data: loadoutsData } = useQuery<TLoadoutsQuery>(LOADOUT_QUERY, {
    variables: {
      game: gameId,
      type: "quick_edit",
      skip: skipExtraQueries,
    },
    skip: !gameId,
  });

  const { data: viewerData } = useQuery<{
    me: {
      mediaUploadUrl: {
        fields: {
          name: string;
          value: string;
        }[];
        key: string;
        url: string;
      };
    };
  }>(ME_QUERY, {
    fetchPolicy: "network-only",
  });

  const [momentCreateClip] = useMutation(MOMENT_CREATE_CLIP, {
    onError: (err: any) => {
      console.log(`momentCreateClip error! ${err.message}`);
    },
  });

  const [momentCreateMontage] = useMutation(MOMENT_CREATE_MONTAGE, {
    onError: (err: any) => {
      console.log(`momentCreateMontage error! ${err.message}`);
    },
  });

  const [getBalance] = useLazyQuery(MY_BALANCE, {
    fetchPolicy: "network-only",
    onError: (err: any) => {
      console.log(`balanceError error! ${err.message}`);
    },
  });

  const loadouts = loadoutsData?.loadouts;
  const moment = momentData?.moment;
  const mediaUploadUrl = viewerData?.me.mediaUploadUrl;

  return {
    loadouts,
    moment,
    momentCreateClip,
    momentCreateMontage,
    getBalance,
    mediaUploadUrl,
  };
};
